import { render, staticRenderFns } from "./ReportQuantityPerMonthPage.vue?vue&type=template&id=66771d53&scoped=true"
import script from "./ReportQuantityPerMonthPage.vue?vue&type=script&lang=js"
export * from "./ReportQuantityPerMonthPage.vue?vue&type=script&lang=js"
import style0 from "./ReportQuantityPerMonthPage.vue?vue&type=style&index=0&id=66771d53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66771d53",
  null
  
)

export default component.exports